var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"d-flex flex-column justify-space-between align-center",attrs:{"loading":_vm.loading,"outlined":""}},[_c('v-card-title',{staticClass:"text-truncate text-overline font-weight-bold"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.title)}})]),_c('v-card-text',{staticClass:"card-text"},[_vm._t("content")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }